import frustumCull from '../frustumCull'
import hsv_rgb from '../hsv_rgb'
import noise3D from '../noise3D'

export default `${noise3D + hsv_rgb}
uniform vec4 uProgress;
uniform vec3 uColor1;
uniform vec4 uRectData;

varying vec3 vPosition;
varying vec3 vNormal;

void main(){
  vec3 no = abs(vNormal);
  float maxComponent = max(no.x, max(no.y, no.z));
  no = vec3(equal(no, vec3(maxComponent)));

  vec2 rainbowFactor = vec2(
    snoise(vec3(vPosition * 0.25 + no * 0.2 + uProgress.y + 2.0)),
    snoise(vec3(vPosition * 0.5 + no + uProgress.y * 2.0))
  ) * 0.5 + 0.5;


  vec3 rainbowColor = uColor1;
  vec3 hsv = rgb2hsv(rainbowColor);
  hsv.r -= rainbowFactor.x * 0.2;
  hsv.g -= rainbowFactor.y * 0.1;
  hsv.b += rainbowFactor.y * 0.2;

  #ifndef IS_GLASS_RENDER
  ${frustumCull}
  #endif

  rainbowColor = hsv2rgb(hsv);
  gl_FragColor = vec4(rainbowColor, 1.0);
}
`
